import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all work order schedules
export const getWorkOrderSchedules = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/work-order-schedule`);
    return response.data;
  } catch (error) {
    console.error('Error fetching work order schedules:', error.response?.data || error);
    throw error;
  }
};

// GET a single work order schedule
export const getWorkOrderScheduleById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/work-order-schedule/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching work order schedule:', error.response?.data || error);
    throw error;
  }
};

// CREATE a new work order schedule
export const createWorkOrderSchedule = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/work-order-schedule`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating work order schedule:', error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing work order schedule
export const updateWorkOrderSchedule = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/work-order-schedule/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating work order schedule:', error.response?.data || error);
    throw error;
  }
};

// DELETE a work order schedule
export const deleteWorkOrderSchedule = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/work-order-schedule/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting work order schedule:', error.response?.data || error);
    throw error;
  }
};
